<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import VueCropper from 'vue-cropperjs';
    
   export default {
      page: {
         title: "Add Clinic",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader, VueCropper },
      data() {
         return {
            title: "Add Clinic",
            items: [
               {
                  text: "Clinics",
                  href: "/clinics",
               },
               {
                  text: "Add Clinic",
                  active: true,
               },        
            ],


            clinic: {
               id: '',
               name : '',
               place: '',
               country_code: 1,
               phone: '',
               latitude: '',
               longitude: '',
               username: '',
               password: '',
               pin_no: '',
            },
            image: "",
            preview_image: "",
            showCropper: false,
            cropperImage: "",
            cropperOptions: {
               aspectRatio: 1,
               viewMode: 1,
               dragMode: 'move',
               autoCropArea: 0.8,
               restore: false,
               guides: false,
               center: false,
               highlight: false,
               cropBoxMovable: true,
               cropBoxResizable: true,
               toggleDragModeOnDblclick: false,
            },
            isSquareCrop: true,

            countries: [],

            clinic_location: '',
            clinic_marker: { position: { lat: '', lng: '' } },
            clinic_center: { lat: '', lng: '' },
            clinic_current_place: '',

            clinic_mapOptions: {
               disableDefaultUI: true,
            },

            errors: {},
            
            loading: false,
         };
      },
      mounted() {
         this.fetchCountryCodes();
      },

      methods: {

         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 

         noSpaces(event) {
            let keyCode = event.keyCode;
            if(keyCode == 32) {
               event.preventDefault();
            } else {
               return;
            }
         },

         alphaSpacesOnly(event) {
            let keyCode = event.keyCode;
            if ((keyCode >= 65 && keyCode <= 90) || 
               (keyCode >= 97 && keyCode <= 122) ||               
               (keyCode == 32)) {
                 return;
            } else {
               event.preventDefault();
            }
         },

         //sets the position of marker when dragged
         clinicHandleMarkerDrag(e) {
            this.clinic_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         },

         //Moves the map view port to marker
         clinicPanToMarker() {
            this.$refs.clinicMapRef.panTo(this.clinic_marker.position);
            this.$refs.clinicMapRef.setZoom(18);
         },

         //Moves the marker to click position on the map
         clinicHandleMapClick(e) {
            this.clinic_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            console.log(e);
         },     

         clinicSetPlace(place) {
            this.clinic_current_place = place;
            if(this.clinic_current_place) {
               const marker = {
                  lat: this.clinic_current_place.geometry.location.lat(),
                  lng: this.clinic_current_place.geometry.location.lng(),
               };
               this.clinic_center = marker;
               this.clinic_marker.position = marker;
               this.clinic_location = place.formatted_address;
            }
         },
         setFile(e) {
            const file = e.target.files[0];
            if (file) {
               // Validate file type
               const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
               if (!allowedTypes.includes(file.type)) {
                  this.$swal("", "Please select a valid image file (JPG, JPEG, PNG)", "error");
                  return;
               }
               
               // Validate file size (max 5MB)
               if (file.size > 5 * 1024 * 1024) {
                  this.$swal("", "Image size should be less than 5MB", "error");
                  return;
               }
               
               this.cropperImage = URL.createObjectURL(file);
               this.showCropper = true;
            }
         },

         cropImage() {
            // Get cropped canvas
            const canvas = this.$refs.cropper.getCroppedCanvas({
               width: 400,
               height: 400,
               imageSmoothingEnabled: true,
               imageSmoothingQuality: 'high',
            });
            
            // Convert canvas to blob
            canvas.toBlob((blob) => {
               // Create a new file from the blob
               const croppedFile = new File([blob], 'cropped-image.jpg', {
                  type: 'image/jpeg',
                  lastModified: Date.now()
               });
               
               this.image = croppedFile;
               this.preview_image = URL.createObjectURL(blob);
               this.showCropper = false;
               
               // Clean up the cropper image URL
               if (this.cropperImage) {
                  URL.revokeObjectURL(this.cropperImage);
                  this.cropperImage = "";
               }
            }, 'image/jpeg', 0.9);
         },

         cancelCrop() {
            this.showCropper = false;
            // Clean up the cropper image URL
            if (this.cropperImage) {
               URL.revokeObjectURL(this.cropperImage);
               this.cropperImage = "";
            }
            // Reset file input
            this.$refs.fileInput.value = '';
         },

         toggleAspectRatio() {
            this.isSquareCrop = !this.isSquareCrop;
            this.cropperOptions.aspectRatio = this.isSquareCrop ? 1 : NaN;
            if (this.$refs.cropper) {
               this.$refs.cropper.setAspectRatio(this.cropperOptions.aspectRatio);
            }
         },

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchCountryCodes() {
            let url = "api/admin/get-countries";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.countries = responseData.countries;
               })
               .catch((err) => console.log(err));
         },

         addClinic() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/clinics/add_new";

            let formData = new FormData();
            formData.append("name", this.clinic.name); 
            formData.append("place", this.clinic.place); 
            formData.append("country_code", this.clinic.country_code); 
            formData.append("phone", this.clinic.phone); 
            formData.append("latitude", this.clinic_marker.position.lat); 
            formData.append("longitude", this.clinic_marker.position.lng); 
            formData.append("username", this.clinic.username); 
            formData.append("password", this.clinic.password); 
            formData.append("pin_no", this.clinic.pin_no); 
            formData.append('image', this.image);

            this.loading = true;

            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.$router.push({ name: 'clinics'});
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        if(error.response.status == 422);{
                           this.$nextTick(() => {
                              const firstErrorField = document.querySelector('.is-invalid');
                              if (firstErrorField) {
                                 firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                 firstErrorField.focus();
                              }
                           });
                        }
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },

         clearForm() {        
            this.clinic.name = "";
            this.clinic.place = "";
            this.clinic.country_code = "";
            this.clinic.phone = "";
            this.clinic.latitude = "";
            this.clinic.longitude = "";
            this.clinic.username = "";
            this.clinic.password = "";
            this.image = '';
            this.preview_image = '';
            this.showCropper = false;
            this.cropperImage = '';
            this.isSquareCrop = true;
            this.errors = {};
         },
      }
   }
</script>

<style scoped>
   .page-loader {
      display: flex;
      align-items: center;
      padding: 10px 0;
   }

   .page-loader img {
      width: 50px;
      height: 50px;
   }
</style>

    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'clinics' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent="addClinic()">
                        
                        <div class="row">
                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Name <span class="text-danger">*</span></label>
                              <b-form-input v-model="clinic.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }" maxlength="255"></b-form-input>

                              <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>

                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Place <span class="text-danger">*</span></label>
                              <b-form-input v-model="clinic.place" v-bind:class="{ 'is-invalid': Boolean(errors.place) }" maxlength="255"></b-form-input>

                              <div v-for="(val, index) in errors.place" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>

                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Phone <span class="text-danger">*</span></label>
                              <b-input-group>
                                 <b-input-group-prepend>
                                    <select class="form-control" v-model="clinic.country_code"  v-bind:class="{ 'is-invalid': Boolean(errors.country_code) }">
                                       <option :value="country.id" v-for="country in countries" :key="country.id">{{country.country_code}}</option>
                                    </select>
                                 </b-input-group-prepend>
                                 <b-form-input v-model="clinic.phone"  v-bind:class="{ 'is-invalid': Boolean(errors.phone) }" @keypress="numbersOnly" maxlength="15"></b-form-input>

                                 <div v-for="(val, index) in errors.country_code" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                                 <div v-for="(val, index) in errors.phone" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-input-group>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Email <span class="text-danger">*</span></label>
                              <b-form-input type="text" v-model="clinic.username" v-bind:class="{ 'is-invalid': Boolean(errors.username) }"></b-form-input>

                              <div v-for="(val, index) in errors.username" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>


                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Password <span class="text-danger">*</span></label>
                              <b-form-input type="password" v-model="clinic.password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }" @keypress="noSpaces" maxlength="16"></b-form-input>

                              <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <div class="form-group col-md-6">
                                 <label>Pin Number <span class="text-danger">*</span></label>
                                 <b-form-input v-model="clinic.pin_no" autocomplete="off" @keypress="numbersOnly" maxlength="4" v-bind:class="{ 'is-invalid': Boolean(errors.pin_no) }"></b-form-input>

                                 <div v-for="(val, index) in errors.pin_no" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>
                           <b-col md="12" class="form-group">
                              <label>Profile Image <span class="text-danger">*</span> <span class="small">[Allowed formats: .jpg, .jpeg, .png, Max size: 5MB]</span></label>

                              
                              <input ref="fileInput" type="file" @change="setFile($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.image) }" />
                              <div v-if="preview_image" class="mt-2">
                                 <img class="avatar-sm" :src="preview_image" alt="Profile Preview">
                                 <p class="text-muted small mt-1">Click "Choose File" to select a different image</p>
                              </div>

                              <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="mb-3">
                              <label class="control-label">Location</label>
                              <GmapAutocomplete @place_changed="clinicSetPlace" class="form-control"  @keypress.enter="$event.preventDefault()" placeholder="Search here to pick the required latitude and longitude..."  :value="clinic_location"/>
                              
                              <GmapMap v-if="clinic_location"
                                 :center="clinic_center"
                                 :zoom="18"
                                 map-style-id="clinic-roadmap"
                                 :options="clinic_mapOptions"
                                 style="width: 100%; height: 50vmin"
                                 ref="clinicMapRef"
                                 @click="clinicHandleMapClick">
                                    <GmapMarker
                                       :position="clinic_marker.position"
                                       :clickable="true"
                                       :draggable="true"
                                       @drag="clinicHandleMarkerDrag"
                                       @click="clinicPanToMarker"
                                    />
                              </GmapMap>                          
                           </b-col>
                          
                          
                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Latitude <span class="text-danger">*</span></label>
                              <b-form-input type="number" step="any" v-model="clinic_marker.position.lat" :class="{ 'is-invalid': Boolean(errors.latitude) }"></b-form-input>

                              <div v-for="(val, index) in errors.latitude" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Longitude <span class="text-danger">*</span></label>
                              <b-form-input type="number" step="any" v-model="clinic_marker.position.lng" :class="{ 'is-invalid': Boolean(errors.longitude) }"></b-form-input>

                              <div v-for="(val, index) in errors.longitude" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </div>

                        <div class="row mt-3">
                           <div class="12">
                              <div v-if="loading" class="page-loader">
                                 <img src="@/assets/images/preloaderspin.gif"/>
                              </div>
                              <div v-else>
                                 <button class="btn btn-primary me-2" type="submit">Save</button>
                                 <router-link :to="{ name: 'clinics' }" class="btn btn-light">Cancel</router-link>
                              </div>
                           </div>
                        </div>
                     </form>
                  </b-card>
               </div>
            </div>
         </div>
      </div>

      <!-- Image Cropper Modal -->
      <b-modal 
         v-model="showCropper" 
         title="Crop Profile Image" 
         size="lg" 
         centered 
         hide-footer
         @hide="cancelCrop"
         class="cropper-modal">
         
         <div class="cropper-container">
            <vue-cropper
               ref="cropper"
               :src="cropperImage"
               :aspect-ratio="cropperOptions.aspectRatio"
               :view-mode="cropperOptions.viewMode"
               :drag-mode="cropperOptions.dragMode"
               :auto-crop-area="cropperOptions.autoCropArea"
               :restore="cropperOptions.restore"
               :guides="cropperOptions.guides"
               :center="cropperOptions.center"
               :highlight="cropperOptions.highlight"
               :crop-box-movable="cropperOptions.cropBoxMovable"
               :crop-box-resizable="cropperOptions.cropBoxResizable"
               :toggle-drag-mode-on-dblclick="cropperOptions.toggleDragModeOnDblclick"
               class="cropper-wrapper">
            </vue-cropper>
         </div>
         
         <div class="cropper-controls mt-3">
            <div class="d-flex justify-content-between align-items-center">
               <div>
                  <button type="button" class="btn btn-outline-primary btn-sm" @click="toggleAspectRatio">
                     <i class="bx bx-crop"></i> 
                     {{ isSquareCrop ? 'Free Ratio' : 'Square Crop' }}
                  </button>
               </div>
               <div>
                  <button type="button" class="btn btn-secondary me-2" @click="cancelCrop">
                     <i class="bx bx-x"></i> Cancel
                  </button>
                  <button type="button" class="btn btn-primary" @click="cropImage">
                     <i class="bx bx-check"></i> Crop & Save
                  </button>
               </div>
            </div>
         </div>
      </b-modal>
   </Layout>
</template>

<style scoped>
.cropper-container {
   height: 400px;
   width: 100%;
}

.cropper-wrapper {
   height: 100%;
   width: 100%;
}

.cropper-controls {
   border-top: 1px solid #e9ecef;
   padding-top: 1rem;
}

.avatar-sm {
   width: 80px;
   height: 80px;
   object-fit: cover;
   border-radius: 8px;
   border: 2px solid #e9ecef;
}

/* Cropper modal specific styles */
.cropper-modal .modal-dialog {
   max-width: 800px;
}

.cropper-modal .modal-body {
   padding: 1rem;
}
</style>
